module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed_mobile.0d25e8a7.jpg";